import React from 'react';
import { PackageVisibility } from '@/types/package';
import { PACKAGE_VISIBILITY_OPTIONS } from '../packageDisplay';
import { FormCard } from './PackageFormControls';

const HINT: Record<PackageVisibility, string> = {
  [PackageVisibility.PUBLIC]:
    'Tampil di katalog sewa untuk semua mitra yang memenuhi condition.',
  [PackageVisibility.PRIVATE]:
    'Tidak tampil di katalog. Hanya terbuka lewat campaign referral Rent.',
};

interface PackageVisibilitySectionProps {
  value: PackageVisibility;
  onChange: (value: PackageVisibility) => void;
  /** Header chip: the saved visibility, on edit. */
  action?: React.ReactNode;
  /** Campaign usage; replaces the Khusus how-to note when given. */
  children?: React.ReactNode;
}

const PackageVisibilitySection: React.FC<PackageVisibilitySectionProps> = ({
  value,
  onChange,
  action,
  children,
}) => (
  <FormCard title="Visibilitas" action={action}>
    <div className="px-5 py-5">
      <p className="mb-3 text-[13px] text-gray-600">
        Atur siapa yang bisa melihat package ini di aplikasi mitra.
      </p>
      <div
        role="radiogroup"
        aria-label="Visibilitas"
        className="grid grid-cols-1 gap-3 sm:grid-cols-2"
      >
        {PACKAGE_VISIBILITY_OPTIONS.map((option) => {
          const checked = value === option.value;
          return (
            <label
              key={option.value}
              className={`flex cursor-pointer items-start gap-2.5 rounded-lg border p-3.5 transition ${
                checked
                  ? 'border-primary bg-purple-50'
                  : 'border-gray-200 bg-white hover:bg-gray-50'
              }`}
            >
              <input
                type="radio"
                name="visibility"
                value={option.value}
                checked={checked}
                onChange={() => onChange(option.value)}
                className="mt-0.5 h-[18px] w-[18px] shrink-0 accent-primary"
              />
              <span className="flex flex-col gap-0.5">
                <span className="text-[14px] font-semibold text-gray-900">
                  {option.label}
                </span>
                <span className="text-[13px] leading-5 text-gray-600">
                  {HINT[option.value]}
                </span>
              </span>
            </label>
          );
        })}
      </div>
      {children ??
        (value === PackageVisibility.PRIVATE && (
          <p className="mt-3 flex items-start gap-2 rounded-lg bg-[#F5F3FF] px-3 py-2.5 text-[13px] leading-5 text-gray-700">
            <i
              className="ri-information-line text-[16px] leading-5 text-primary"
              aria-hidden="true"
            />
            <span>
              Pilih package ini di On Demand System › Campaigns › Referral
              campaign. Satu package Khusus dipakai satu campaign aktif atau
              terjadwal pada satu waktu (draf belum memesannya), lalu bisa
              dipakai lagi setelah campaign itu selesai.
            </span>
          </p>
        ))}
    </div>
  </FormCard>
);

export default PackageVisibilitySection;
